import React from 'react';
import BubbleButton from './BubbleButton';
import BubbleBadge from './BubbleBadge';
import { createCalendar, CalendarDateRange } from './abstracts/Calendar';

// Re-export shared types under Bubble-prefixed names
export type { CalendarDateRange };
export type { CalendarProps } from './abstracts/Calendar';

export default createCalendar({
  className: 'bg-white border rounded shadow',
  titleClassName: 'text-navy font-bold',
  daysClassName: 'text-slate font-bold',
  NavButton: ({ direction, onClick }) => (
    <BubbleButton
      icon={direction === 'prev' ? 'arrow-left' : 'arrow-right'}
      onClick={onClick}
      variant="navy"
      inverse
      className="p-1-i"
    />
  ),
  DayButton: ({ day, dayContext, onClick }) => {
    const { isHighlighted, isCurrentDate, isOutOfBounds } = dayContext;

    return (
      <BubbleButton
        variant={isHighlighted || isCurrentDate ? 'ocean' : isOutOfBounds ? 'smoke' : 'titanium'}
        inverse={!isHighlighted}
        onClick={onClick}
        appearance="circled"
        className="p-0-i flex items-center justify-center"
        style={{ width: '35px', height: '35px' }}
      >
        <span className={isCurrentDate ? 'font-bold' : 'font-normal'}>{Math.abs(day)}</span>
      </BubbleButton>
    );
  },
  Badge: ({ color }) => (
    <BubbleBadge circle color={color} style={{ width: '5px', height: '5px' }} className="p-0-i" />
  ),
  TodayButton: ({ onClick }) => (
    <BubbleButton variant="navy" inverse onClick={onClick}>
      Today
    </BubbleButton>
  ),
  ClearButton: ({ onClick }) => (
    <BubbleButton variant="smoke" inverse onClick={onClick}>
      Clear
    </BubbleButton>
  ),
});
